// extracted by mini-css-extract-plugin
module.exports = {"finance-outer":"_19HXt","border":"_1n3nd","heading":"_2sqlX","action":"_2jrM2","credit":"_1z65l","progressBarOuter":"_1yBZQ","progressBarPercent":"_3mccG","close":"_7-vtO"};